(function () {
  const T = (key, fallback) => (window.aifCartStrings && window.aifCartStrings[key]) || fallback;

  /* ---------- Bekeken producten en zoekopdrachten onthouden (alleen in deze browser) ---------- */
  const KEY_RECENT = 'aif_recent_products';
  const KEY_SEARCH = 'aif_last_search';
  const store = {
    get(k, d) {
      try {
        const v = JSON.parse(localStorage.getItem(k));
        return v == null ? d : v;
      } catch (e) {
        return d;
      }
    },
    set(k, v) {
      try {
        localStorage.setItem(k, JSON.stringify(v));
      } catch (e) {}
    },
  };
  try {
    const meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    const pid = meta && meta.product && meta.product.id;
    if (pid) {
      const list = store.get(KEY_RECENT, []).filter((id) => String(id) !== String(pid));
      list.unshift(pid);
      store.set(KEY_RECENT, list.slice(0, 10));
    }
    if (/\/search/.test(window.location.pathname)) {
      const q = new URLSearchParams(window.location.search).get('q');
      if (q && q.trim()) store.set(KEY_SEARCH, q.trim().slice(0, 80));
    }
  } catch (e) {}

  /* ---------- Hover mini-winkelwagen ---------- */
  const mq = window.matchMedia('(hover: hover) and (min-width: 990px)');
  const icon = document.getElementById('cart-icon-bubble');
  if (!icon || /\/cart\/?$/.test(window.location.pathname)) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const drop = document.createElement('div');
  drop.className = 'cart-mini';
  drop.setAttribute('role', 'dialog');
  drop.setAttribute('aria-label', T('cart', 'Cart'));
  const main = document.createElement('div');
  main.className = 'cart-mini__main';
  drop.appendChild(main);
  document.body.appendChild(drop);

  const recs = document.createElement('cart-upsell');
  recs.className = 'cart-upsell cart-mini__recs';
  recs.dataset.mode = 'mini';

  let openTimer;
  let closeTimer;

  const place = () => {
    const r = icon.getBoundingClientRect();
    drop.style.top = `${Math.round(r.bottom + 10)}px`;
    drop.style.right = `${Math.max(12, Math.round(document.documentElement.clientWidth - r.right - 16))}px`;
  };

  const fetchItems = async (url) => {
    const res = await fetch(url);
    if (!res.ok) return [];
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    return [...doc.querySelectorAll('.cart-upsell__item')];
  };

  const loadRecs = async () => {
    try {
      let items = [];
      let title = '';
      const recent = store.get(KEY_RECENT, []);
      for (const id of recent.slice(0, 3)) {
        items = await fetchItems(`${root}recommendations/products?section_id=cart-upsell&product_id=${id}&limit=10&intent=related`);
        if (items.length >= 2) {
          title = T('recsViewed', '');
          break;
        }
      }
      const q = store.get(KEY_SEARCH, null);
      if (items.length < 2 && q) {
        items = await fetchItems(`${root}search?q=${encodeURIComponent(q)}&type=product&section_id=cart-recs-list`);
        if (items.length >= 2) title = T('recsSearch', '');
      }
      if (items.length < 2) {
        items = await fetchItems(`${root}collections/all?sort_by=best-selling&section_id=cart-recs-list`);
        title = T('recsPopular', '');
      }
      items = items.slice(0, 2);
      recs.innerHTML = items.length
        ? `<p class="cart-upsell__heading">${title}</p><div class="cart-upsell__list">${items.map((i) => i.outerHTML).join('')}</div>`
        : '';
    } catch (e) {
      recs.innerHTML = '';
    }
  };

  const load = async () => {
    const res = await fetch(`${root}?sections=cart-mini`);
    const json = await res.json();
    const doc = new DOMParser().parseFromString(json['cart-mini'], 'text/html');
    const inner = doc.querySelector('.cart-mini__inner');
    if (!inner) return;
    main.innerHTML = inner.outerHTML;
    const slot = main.querySelector('.cart-mini__recs-slot');
    if (slot) slot.appendChild(recs);
  };

  const open = async () => {
    if (!mq.matches) return;
    const notification = document.getElementById('cart-notification');
    if (notification && notification.classList.contains('active')) return;
    try {
      await Promise.all([load(), loadRecs()]);
    } catch (e) {
      return;
    }
    place();
    drop.classList.add('is-open');
  };

  const close = () => {
    clearTimeout(openTimer);
    closeTimer = setTimeout(() => drop.classList.remove('is-open'), 250);
  };

  icon.addEventListener('mouseenter', () => {
    clearTimeout(closeTimer);
    if (drop.classList.contains('is-open')) return;
    openTimer = setTimeout(open, 120);
  });
  icon.addEventListener('mouseleave', close);
  drop.addEventListener('mouseenter', () => clearTimeout(closeTimer));
  drop.addEventListener('mouseleave', close);
  document.addEventListener('cart-mini:refresh', () => load().catch(() => {}));
  window.addEventListener('scroll', () => drop.classList.remove('is-open'), { passive: true });
  window.addEventListener('resize', () => drop.classList.remove('is-open'));
})();
